const toJsType = {
    geoserver: {
        "string": "string",
        "int": "number",
        "date-time": "datetime",
        "Point": "geometry.point",
        "MultiPoint": "geometry.point",
        "LineString": "geometry.lineString",
        "MultiLineString": "geometry.multiLineString",
        "Polygon": "geometry.polygon",
        "MultiPolygon": "geometry.multiPolygon",
    },
    esri:{
        "esriFieldTypeSmallInteger":"number",
        "esriFieldTypeInteger":"number",
        "esriFieldTypeSingle":"number",
        "esriFieldTypeDouble":"number",
        "esriFieldTypeString":"string",
        "esriFieldTypeDate":"datetime",
        "esriFieldTypeOID":"number",
        "esriFieldTypeGeometry":"string",
        "esriFieldTypeBlob":"object",
        "esriFieldTypeRaster":"object",
        "esriFieldTypeGUID":"string",
        "esriFieldTypeGlobalID":"string",
        "esriFieldTypeXML":"string"
    }
};

function convertToJsType(server, typeName) {
    let dict = toJsType[server];
    if (!dict) return typeName;
    let resultTypeName = dict[typeName] || typeName;
    return resultTypeName;
}

module.exports = {
    convertToJsType: convertToJsType
};
